import React from 'react';
import { Alert } from 'react-bootstrap';
import { formatQueryError } from 'utils/queryHelpers';

/**
 * Reusable error state for RTK Query failures.
 * Shows a visible alert so a GET failure can never look like "no records".
 *
 * Usage:
 *   const { data, error, isLoading } = useGetClientsQuery(...);
 *   if (error) return <QueryErrorState error={error} />;
 *   if (isLoading) return <Spinner />;
 */
const QueryErrorState = ({ error, onRetry, title = 'Erreur de chargement' }) => {
  const message = formatQueryError(error);
  return (
    <Alert variant="danger" className="m-3">
      <Alert.Heading>{title}</Alert.Heading>
      <p className="mb-2">{message}</p>
      {onRetry && (
        <button className="btn btn-outline-danger btn-sm" onClick={onRetry}>
          Réessayer
        </button>
      )}
    </Alert>
  );
};

export default QueryErrorState;
